import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';
import { QuoteLineParams } from './types';

export function quoteLineDeleted(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const { quoteLineUuid } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.status = 'deleting';
}

function quoteLineDeletionSucceededBase(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const { quoteLineUuid } = action.payload;

  Object.entries(state.issues).forEach(([issueId, issue]) => {
    if (issue.area === 'quoteLine' && issue.quoteLineUuid === quoteLineUuid) {
      deleteIssue(state, issueId);
    }
  });

  state.quoteLineUuids = state.quoteLineUuids.filter(
    (id) => id !== quoteLineUuid,
  );

  delete state.quoteLines[quoteLineUuid];
}

export const quoteLineDeletionSucceeded = withSaveStateUpdate(
  quoteLineDeletionSucceededBase,
);

export function quoteLineDeletionFailed(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const { quoteLineUuid } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.status = 'deletion-failed';

  upsertIssue(
    state,
    buildIssueId({
      area: 'quoteLine',
      quoteLineUuid,
      type: 'rejected',
    }),
    {
      title: 'Failed to Delete Line',
      description: 'Quote line could not be deleted in the database',
      area: 'quoteLine',
      quoteLineUuid,
      severity: 'error',
      type: 'rejected',
      action: {
        type: 'unrecoverable',
      },
    },
  );
}
